import { ActionTree } from 'vuex'
import { Contactlensname, DataState } from './types'
import { RootState } from '../types'
import { db } from '../../firebase'

export const actions: ActionTree<DataState, RootState> = {
  // eslint-disable-next-line
  async setContactlenses ({ commit }): Promise<any> {
    // fetch contactlenses from firebase
    const contactlenses: Contactlensname[] = []
    const snapshot = await db.collection('contactlenses').get()
    if (!snapshot.empty) {
      snapshot.forEach(doc => contactlenses.push({ id: Number.parseInt(doc.id), name: doc.data().name }))
    }
    contactlenses.sort((a: {name: string; id: number}, b: {name: string; id: number}) => a.name.localeCompare(b.name))
    commit('setContactlenses', contactlenses)
  },
  // eslint-disable-next-line
  async setShops ({ commit }): Promise<any> {
    // fetch shops from firebase
    const shops: Contactlensname[] = []
    const snapshot = await db.collection('shops').get()
    if (!snapshot.empty) {
      snapshot.forEach(doc => shops.push({ id: Number.parseInt(doc.id), name: doc.data().name }))
    }
    shops.sort((a: {name: string; id: number}, b: {name: string; id: number}) => a.name.localeCompare(b.name))
    commit('setShops', shops)
  }
}
